import { graphql } from "../../graphql";

export const GridSettingsThemeFragment = graphql(`
  fragment GridSettingsTheme on grid_settings {
    user_id
    theme
  }
`);
export const GridSettingsThemeQuery = graphql(`
  query GridSettingsThemeQuery($userId: String!) {
    grid_settings(where: { user_id: { _eq: $userId } }) {
      ...GridSettingsTheme
    }
  }
`);
export const GridSettingsThemeUpdate = graphql(`
  mutation GridSettingsThemeUpdate(
    $userId: String!
    $theme: theme_enum
  ) {
    update_grid_settings_by_pk(
      pk_columns: { user_id: $userId }
      _set: { theme: $theme }
    ) {
      user_id
      theme
    }
  }
`);
